export default "__VITE_ASSET__BmnUrVKT__"